import {
  GLOBAL_COLOR_CANVAS_DEFAULT_DARK,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
  SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_LIGHT,
  SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_DARK,
  SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_LIGHT,
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_LIGHT,
  SEM_TYPOGRAPHY_UI_MD_COPY,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_100_DARK,
  SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_100_LIGHT,
  SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_300_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_700_DARK,
  SYS_SPACE_RELATIVE_2_XL,
  SYS_SPACE_RELATIVE_2_XS,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_MD,
  SYS_SPACE_RELATIVE_SM,
  SYS_SPACE_RELATIVE_XL,
  SYS_SPACE_RELATIVE_XS,
  SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL,
  SYS_TYPOGRAPHY_COPY_ORDER3_SHORT,
  SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD,
  SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS,
  SYS_TYPOGRAPHY_UI_ORDER2_NORMAL,
} from '@oneaudi/unified-web-common';
import {
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
  SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_DARK,
  SEM_COLOR_NAVIGATION_SURFACE_STROKE_INTERACTIVE_DARK,
  SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK,
  SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL,
  SYS_BORDER_RADIUS_MD,
  SYS_BORDER_RADIUS_SM,
  SYS_BORDER_WIDTH_100,
  SYS_COLOR_SURFACE_SIGNAL_FOCUS_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK,
  SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK,
  SYS_SPACE_FIXED_50,
  SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
} from '@oneaudi/unified-web-alpha-common';
import { CustomTheme } from '../@types/theme';
import { Theme } from '../types';

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const colorsDark = {
  primary: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_DARK
    : SYS_GRADIENT_ELEVATION_LEVEL1_FILL_DARK,
  icons: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_LIGHT,
  text: process.env.IS_LEGACY
    ? SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_100_DARK
    : SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_IDLE_DARK,
  background: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_DARK
    : SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK,
  popoverBackground: process.env.IS_LEGACY
    ? GLOBAL_COLOR_CANVAS_DEFAULT_DARK
    : SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK,
  texturedBackground: process.env.IS_LEGACY
    ? SYS_COLOR_SURFACE_NEUTRAL_700_DARK
    : SYS_GRADIENT_ELEVATION_LEVEL2_FILL_DARK,
  divider: process.env.IS_LEGACY
    ? SYS_COLOR_SURFACE_NEUTRAL_700_DARK
    : SEM_COLOR_UI_FOREGROUND_DIVIDER_DEFAULT_DARK,
  dropShadow: `drop-shadow(0 1px 2px ${SYS_COLOR_SURFACE_NEUTRAL_700_DARK}) drop-shadow(0 2px 6px ${SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_300_LIGHT})`,
  activeLink: SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_DARK,
  activeIndicator: SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_DARK,
  mobileOverviewText: process.env.IS_LEGACY
    ? ''
    : SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_INTERACTIVE_DARK,
  mobileSublevelOpened: process.env.IS_LEGACY ? '' : SYS_GRADIENT_ELEVATION_LEVEL3_FILL_DARK,
  borderRadius: process.env.IS_LEGACY ? '' : SYS_BORDER_RADIUS_SM,
  borderRadiusPopover: process.env.IS_LEGACY ? '' : SYS_BORDER_RADIUS_MD,
  borderWidth: process.env.IS_LEGACY ? '' : SYS_BORDER_WIDTH_100,
  border: process.env.IS_LEGACY ? '' : SEM_COLOR_NAVIGATION_SURFACE_STROKE_INTERACTIVE_DARK,
  borderFocusColor: process.env.IS_LEGACY ? '' : SYS_COLOR_SURFACE_SIGNAL_FOCUS_DARK,
};

const colorsLight = {
  primary: process.env.IS_LEGACY ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT : '',
  text: process.env.IS_LEGACY ? SYS_COLOR_FOREGROUND_INTERACTIVE_SECONDARY_100_LIGHT : '',
  background: process.env.IS_LEGACY ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT : '',
  texturedBackground: process.env.IS_LEGACY ? 'rgba(0,0,0,0.05)' : '',
  popoverBackground: process.env.IS_LEGACY ? GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT : '',
  divider: 'hsla(33,0%,85%,1)',
  activeLink: SEM_COLOR_NAVIGATION_FOREGROUND_TEXT_ACTIVE_LIGHT,
  dropShadow: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1)) drop-shadow(0 2px 6px rgba(0,0,0,0.2))',
  activeIndicator: process.env.IS_LEGACY
    ? SEM_COLOR_NAVIGATION_FOREGROUND_INDICATOR_ACTIVE_LIGHT
    : '',
  icons: SEM_COLOR_ACTION_PRIMARY_FOREGROUND_ICON_DEFAULT_DARK,
};

export const spacing = {
  xxs: SYS_SPACE_RELATIVE_2_XS,
  xcs: '5px',
  xs: SYS_SPACE_RELATIVE_XS,
  sm: SYS_SPACE_RELATIVE_SM,
  md: SYS_SPACE_RELATIVE_MD,
  lg: SYS_SPACE_RELATIVE_LG,
  xl: SYS_SPACE_RELATIVE_XL,
  xxl: SYS_SPACE_RELATIVE_2_XL,
  spaceFixed: SYS_SPACE_FIXED_50,
};

const typography = {
  parentItem: SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS,
  parentItemLarge: SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD,
  copy1: process.env.IS_LEGACY
    ? SEM_TYPOGRAPHY_UI_MD_COPY
    : SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL,
  copy2: SYS_TYPOGRAPHY_COPY_ORDER3_SHORT,
  order2: process.env.IS_LEGACY
    ? SYS_TYPOGRAPHY_UI_ORDER2_NORMAL
    : SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL,
  order3: SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL,
};

const easing = {
  duration: '500ms',
  transition: '500ms cubic-bezier(0.75, 0.02, 0.5, 1)',
};

export const darkTheme: CustomTheme = {
  name: Theme.DARK,
  colors: colorsDark,
  colorsInverted: colorsLight,
  breakpoints,
  spacing,
  typography,
  easing,
};

export const lightTheme: CustomTheme = {
  name: Theme.LIGHT,
  colors: colorsLight,
  colorsInverted: colorsDark,
  breakpoints,
  spacing,
  typography,
  easing,
};
